
let defaultState = {
    globalLoaderOn: false,
    cornerLoaderOn: false,
    subdomainInfo: {},
    navInstructions: {},
    vars: {}
}

export default (state = defaultState, action) => {

    switch (action.type) {
        case 'TOGGLE_GLOBAL_LOADER':
            return {...state, globalLoaderOn: [null, undefined].includes(action.boolean) ? !state.globalLoaderOn : action.boolean};

        case 'UPDATE_NAV_INSTRUCTIONS':
            return {...state, navInstructions: action.data}

        case 'SET_SUBDOMAIN_INFO':
             return {...state, subdomainInfo: action.data}

        case 'SET_SESSION_VAR':
            return {...state, vars: {...state.vars, ...action.data}}

        case 'CLEAR_SESSION_VARS':
            return {...state, vars: {}}

        default:
            return state
    }

}
